/**
 * 教育局Id
 */
export const TENANT_ID = 'TENANT_ID';

/**
 * 一级栏目ID
 */
export const FIRST_COLUMN_KEY = 'FIRST_COLUMN';